import React, {useState} from 'react';

import {
    ContractsGenerationView,
} from 'src/modules/admin/contracts-generation/contracts-generation.view';
import {
    runEventContractGenerator,
    runEventContractGeneratorFailure,
    runEventContractGeneratorSuccess,
} from 'src/openapi/apis/EventContractGeneratorControllerApi';
import {useAppDispatch} from 'src/store';

export const ContractsGenerationController = () => {
    const dispatch = useAppDispatch();
    const [result, setResult] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const onClick = () => {
        setIsLoading(true);
        dispatch(runEventContractGenerator()).then(res => {
            if (res.type === runEventContractGeneratorSuccess.type) {
                setResult('OK');
                setIsLoading(false);
            }

            if (res.type === runEventContractGeneratorFailure.type) {
                setResult('FAIL');
                setIsLoading(false);
            }
        });
    };

    return (
        <ContractsGenerationView
            isLoading={isLoading}
            onClick={onClick}
            generatedResult={result}
        />
    );
};
